module.exports = __webpack_public_path__ + "static/hero-img-02-0ede6e795e424c8b02232392d20f4043.png";